import React, { Component } from 'react'
import * as PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { conciliationOperations } from '../../../../state/ducks/conciliations'
import { PaginationSizeLayout, TableGeneratedLayout } from '../../../layouts'
import { PaginationLayout } from '../../../layouts/pagination'

class ConciliationMissingsBTableGenerated extends Component {
  constructor (props) {
    super(props)

    // state
    this.state = {
      fullPage: false,
      queryParams: {}
    }

    this.getMissingsBTableGenerated = this.getMissingsBTableGenerated.bind(this)
    this.fullPage = this.fullPage.bind(this)
    this.getMissingsBTableGenerated = this.getMissingsBTableGenerated.bind(this)
    this.onPaginationChange = this.onPaginationChange.bind(this)
    this.onPaginationSizeChange = this.onPaginationSizeChange.bind(this)
    this.onSortBy = this.onSortBy.bind(this)
  }

  componentDidMount () {
    if (!this.state.queryParams.connection_id) {
      this.setState({
        queryParams: {
          connection_id: this.props.conciliation.destination_connection,
          table_name: this.props.conciliation.parameters.missing_b === true
            ? 'missings__' + this.props.conciliation.name + '__' + this.props.conciliation.parameters.b_prefix
            : this.props.conciliation.parameters.missing_b
        }
      }, () => {
        if (!this.props.isLoading) {
          this.props.getMissingsBTableGenerated(this.state.queryParams)
        }
      })
    }
  }

  getMissingsBTableGenerated () {
    this.props.getMissingsBTableGenerated(this.state.queryParams)
  }

  fullPage (fullPage) {
    const currentValue = this.state.fullPage
    if (currentValue) {
      fullPage = null
    }
    this.setState({ fullPage })
  }

  updateQueryParams (key, value) {
    const { queryParams } = this.state
    queryParams[key] = value
    if (key === 'search') {
      queryParams.page = 1
    }
    this.setState({ queryParams }, () => this.getMissingsBTableGenerated())
  }

  onPaginationSizeChange (size) {
    this.updateQueryParams('pagination_size', size)
  }

  onSortBy (att, sortBy) {
    this.updateQueryParams('ordering', sortBy === -1 ? '-' + att : att)
  }

  onPaginationChange (page) {
    this.updateQueryParams('page', page)
  }

  render () {
    return (
            <>
                <div className={
                    ' block block-themed block-opt-refresh-icon7 ' +
                    (this.props.isLoading ? ' block-opt-refresh ' : '') +
                    (this.state.fullPage ? ' block-opt-fullscreen ' : '')
                }>
                    <div className="block-header bg-primary-dark">
                        <ul className="block-options">
                            <li>
                                <button type="button"
                                        onClick={this.fullPage.bind('loaded-table')}
                                >
                                    <i className="si si-size-fullscreen"/>
                                </button>
                            </li>
                            <li>
                                <button type="button">
                                    <i className="fa fa-download"/>
                                </button>
                            </li>
                            <li>
                                <button type="button"
                                        data-toggle="block-option"
                                        onClick={this.getMissingsBTableGenerated}
                                >
                                    <i className="si si-refresh"></i>
                                </button>
                            </li>
                        </ul>
                        <h3 className="block-title">{this.state.table_name}</h3>
                    </div>
                    <div className="block-content">
                        {/* Pagination Size */}
                        <PaginationSizeLayout
                            onPaginationSizeChange={this.onPaginationSizeChange}/>
                        {/* End Pagination Size */}
                        <div className="table-scrolling">
                            {/* Table */}
                            <TableGeneratedLayout
                                rows={this.props.missingsBTableGenerated}
                                onSortBy={this.onSortBy}
                            />
                            {/* End Table */}
                        </div>
                        {/* Pagination */}
                        <PaginationLayout
                            pagination={this.props.paginationData}
                            onPaginationChange={this.onPaginationChange}
                        />
                        {/* End Pagination */}
                    </div>
                </div>
            </>
    )
  }
}

// Set propTypes
ConciliationMissingsBTableGenerated.propTypes = {
  conciliation: PropTypes.object.isRequired,
  missingsBTableGenerated: PropTypes.array,
  isLoading: PropTypes.bool,
  paginationData: PropTypes.object
}

// Set defaultProps
ConciliationMissingsBTableGenerated.defaultProps = {
  conciliation: {},
  missingsBTableGenerated: [],
  isLoading: true,
  paginationData: {}
}

// mapStateToProps
const mapStateToProps = (state) => ({
  missingsBTableGenerated: state.conciliations.missingsBTableGeneratedReducer.data.results,
  isLoading: state.conciliations.missingsBTableGeneratedReducer.loading,
  paginationData: state.conciliations.missingsBTableGeneratedReducer.data.pagination_data
})

// mapStateToProps
const mapDispatchToProps = {
  getMissingsBTableGenerated: conciliationOperations.getMissingsBTableGenerated
}

// Export Class
const _ConciliationMissingsBTableGenerated = connect(mapStateToProps,
  mapDispatchToProps)(ConciliationMissingsBTableGenerated)
export { _ConciliationMissingsBTableGenerated as ConciliationMissingsBTableGenerated }
